import axios from 'axios';
import BannersEditar from '../types/BannersEditar';
    
async function InsertarBanner(BannerNuevo: BannersEditar) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_banner";
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "banner": {
                    "titulo": BannerNuevo.titulo,
                    "enlace": BannerNuevo.enlace,
                    "habilitado": BannerNuevo.habilitado,
                    "mostrar_web": BannerNuevo.mostrar_web,
                    "fchalta": BannerNuevo.fchalta,
                    "fchmodificado": BannerNuevo.fchmodificado,
                    "dado_baja": BannerNuevo.dado_baja,
                    "fchbaja": BannerNuevo.fchbaja,
                    "banner_mime": BannerNuevo.banner_mime,
                    "banner_content": BannerNuevo.banner_content,
                    "banner_name": BannerNuevo.banner_name
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarBanner;